import JSONApiClient from '../jsonapi-service';
import { BRIEF, CONTRACT, SIGNED_CONTRACT } from '../static-configuration';
import { authService } from '../auth-service';
import AxiosService from '../axios-service';

export function createDiscussion(discussionData) {
  const client = JSONApiClient();

  const discussion = client.create('discussions');

  discussion.set('name', discussionData.name);
  discussion.set('members', discussionData.members);
  discussion.set('channelURL', discussionData.channelURL);
  discussion.set('campaign', { type: 'campaigns', id: discussionData.campaignId });
  discussion.set('organisations', discussionData.organisationsList);

  return discussion.sync().then(response => response);
}

export function getDiscussionOld(discussionId) {
  const client = JSONApiClient();

  return client
    .get('discussions', discussionId, { include: ['documents', 'deliverables'] })
    .then(response => response);
}

export function addDiscussionDocument(discussionId, documentData) {
  const client = JSONApiClient();

  const documentDataJSON = documentData.toJSONTree();
  const docType = documentDataJSON.docType;
  const approved = documentDataJSON.approved;
  const docId = documentDataJSON.id;

  return client.get('discussions', discussionId, {}).then(discussion => {
    discussion.relationships('documents').add(documentData);
    if (!approved && docType === BRIEF) discussion.set('currentBrief', docId);
    if (!approved && docType === CONTRACT) discussion.set('currentContract', docId);
    if (approved && docType === SIGNED_CONTRACT) discussion.set('signedContract', docId);
    return discussion.sync();
  });
}

export function updateDiscussionDeliverables(discussionId, deliverableData) {
  const client = JSONApiClient();

  return client.get('discussions', discussionId, {}).then(discussion => {
    discussion.relationships('deliverables').add(deliverableData);
    return discussion.sync();
  });
}

export function removeMemberFromDiscussion(discussionId, campaignPermission) {
  const client = JSONApiClient();

  client.get('discussions', discussionId, {}).then(discussion => {
    discussion.relationships('members').remove(campaignPermission);
    return discussion.sync().then(discussion => discussion);
  });
}

function makeDiscussionQuery(discussionId) {
  const query = `
  query Discussions {
    discussions(id: "${discussionId}") {
      id
      name
      members {
        id
        user {
          id
        }
        email
        role
        name
      }
      organisations {
        id
        name
        orgType
        influencer {
          id
          name
          thumbnail
        }
      }
      documents {
        id
        name
        filePath
        docType
        fileType
        size
        message
        discussion {
          id
        }
        approved
        createdDate
        createdBy
        approvedBy
        approvalDate
        removed
        version
      }
      currentBrief
      currentContract
      signedContract
      deliverables {
        id
        title
        channelType
        assetType
        dueDate
        liveDateStart
        liveDateEnd
        live
        description
        createdBy
        createdDate
        discussion {
          id
          name
        }
        document {
          id
          name
          filePath
          fileType
          size
          message
          approved
          approvedBy
          approvalDate
          version
        }
        documents {
          id
          name
          filePath
          fileType
          size
          message
          approved
          approvedBy
          approvalDate
          version
        }
        version
        comments {
          id
          comment
          commentType
          deliverable {
            id
          }
          document {
            id
            name
          }
          user {
            id
            name
          }
          createdBy
          createdDate
        }
      }
      campaign {
        id
      }
      channelURL
      budget
      budgetStatus
      discountCode
      commission
      discussionType
      invitations {
        id
        status
        link
        metadata
      }
      trackedVideos {
        id
        youtubeId
        campaign {
          id
          name
        }
        discussion {
          id
          name
        }
        createdBy
        createdDate
      }
      trackedAssets {
        id
        assetId
        assetURL
        platform
        assetType
        campaign {
          id
          name
        }
        discussion {
          id
          name
        }
        createdBy
        createdDate
        createdSource
        publishedDate
      }
    }
  }
  `;
  return query;
}

export function getDiscussion(discussionId) {
  const axiosService = new AxiosService(process.env.REACT_APP_API_BASE_URL, 10000, {
    Authorization: `Bearer ${authService.getToken()}`,
  });

  const query = makeDiscussionQuery(discussionId);

  return axiosService
    .post('', {
      query,
      variables: null,
      operationName: null,
    })
    .then(response => response.data.data.discussions[0]);
}

function makeReceiveMessageDiscussionQuery(discussionId) {
  const query = `
  query Discussions {
    discussions(id: "${discussionId}") {
      id
      name
      campaign {
        id
        name
      }
    }
  }
  `;
  return query;
}

export function getReceiveMessageDiscussion(discussionId) {
  const axiosService = new AxiosService(process.env.REACT_APP_API_BASE_URL, 10000, {
    Authorization: `Bearer ${authService.getToken()}`,
  });

  const query = makeReceiveMessageDiscussionQuery(discussionId);

  return axiosService
    .post('', {
      query,
      variables: null,
      operationName: null,
    })
    .then(response => response.data.data.discussions[0]);
}

export function updateDiscussionTrackedVideos(discussionId, trackedVideo) {
  const client = JSONApiClient();

  return client.get('discussions', discussionId, {}).then(discussion => {
    discussion.relationships('trackedVideos').add(trackedVideo);
    return discussion.sync();
  });
}

export function updateDiscussionTrackedAssets(discussionId, trackedAsset) {
  const client = JSONApiClient();

  return client.get('discussions', discussionId, {}).then(discussion => {
    discussion.relationships('trackedAssets').add(trackedAsset);
    return discussion.sync();
  });
}

export function updateBudgetServer(budget, status, d) {
  const client = JSONApiClient();

  return client.get('discussions', d, {}).then(discussion => {
    discussion.set('budget', budget);
    discussion.set('budgetStatus', status);
    return discussion.sync();
  });
}



/** WEBPACK FOOTER **
 ** ./src/utils/jsonapi-functions/discussions.js
 **/